<template>
  <div class="list-container">
    <div v-for="item in levelList" :key="item.type">
      <LevelItem :info="item" />
    </div>
  </div>
</template>

<script>
import LevelJson from "../json/index.json";
import LevelItem from "./item";
export default {
  components: {LevelItem},
  props: {},
  data() {
    return {
      levelList: LevelJson
    }
  },
  mounted() { },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>